export default "__VITE_ASSET__jD6NLhLt__"